import { lazy, Suspense } from 'react';

/// Components
import Index from './jsx';
import { connect } from 'react-redux';
import { Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
/// Style

import './css/style.css';

//Okta import

import { toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import CustomLoginCallback from './jsx/pages/CustCallback';
import { oktaAuth } from './services/AuthService';
import DirectLogin from './jsx/pages/DirectLogin';
import ForgotPassword from './jsx/pages/ForgotPassword';
import ResetPassword from './jsx/pages/ResetPassword';
import ChangePassword from './jsx/pages/ChangePassword';
import Logout from './jsx/pages/Logout';

const Login = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import('./jsx/pages/Login')), 500);
  });
});

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

function App(props) {
  const navigate = useNavigate();
  const restoreOriginalUri = (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin));
  };

  return (
    <>
      <Suspense
        fallback={
          <div id="preloader">
            <div className="sk-three-bounce">
              <div className="sk-child sk-bounce1"></div>
              <div className="sk-child sk-bounce2"></div>
              <div className="sk-child sk-bounce3"></div>
            </div>
          </div>
        }
      >
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
          <Routes>
            <Route path="" element={<DirectLogin />} />
            <Route path="/login" element={<DirectLogin />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/external-login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/login/callback" element={<CustomLoginCallback />} />
            {/* <Route path="*" element={<Error404 />} /> */}
          </Routes>
          <Index />
        </Security>
      </Suspense>
    </>
  );
}

const mapStateToProps = (state) => {
  return {};
};

//export default connect((mapStateToProps)(App));
export default withRouter(connect(mapStateToProps)(App));
